import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    Input,
} from '@angular/core';
import { IEntity, SafeAny, TableAction, TableRow } from '@pf/shared-common';

@Component({
    selector: 'pf-table-actions',
    templateUrl: './table-actions.component.html',
    styleUrls: ['./table-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableActionsComponent<T extends IEntity> {
    private readonly cdr = inject(ChangeDetectorRef);
    private _actions: TableAction<T>[] = [];
    private _row: TableRow<T> = null as SafeAny;
    firstAction: TableAction<T> | null = null;
    moreActions: TableAction<T>[] | null = null;

    @Input() set actions(actions: TableAction<T>[] | null) {
        if (!actions || actions.length === 0) {
            return;
        }

        this._actions = (actions || []).map(action => ({ ...action }));
        this.setupActions();
    }

    get actions() {
        return this._actions;
    }

    @Input() index!: number;

    @Input({ required: true }) set row(row: TableRow<T>) {
        this._row = row;
        this.setupActions();
    }

    get row() {
        return this._row;
    }

    actionClicked(action: TableAction<T>) {
        action.onClick(this.row, this.index);
    }

    private setupActions() {
        if (!this.actions || !this.row) {
            return;
        }
        this.actions.forEach(action => {
            if (action.onRowChange && this.row) {
                action.onRowChange(this.row, action);
            }
        });
        const displayedActions = this.actions.filter(x => !x.hide);
        if (displayedActions.length > 0) {
            this.firstAction = displayedActions[0];
        } else {
            this.firstAction = null;
        }
        if (displayedActions.length > 1) {
            this.moreActions = displayedActions.slice(1);
        } else {
            this.moreActions = null;
        }
        this.cdr.markForCheck();
    }
}
